export enum USER_ACTIVITY_STATUS {
    EMPTY,
    NEW,
    ONLINE,
    INSIDER,
    AMBASSADOR,
}

export const getUserJoinedStatusText = (
    status: USER_ACTIVITY_STATUS,
): string => {
    switch (status) {
        case USER_ACTIVITY_STATUS.NEW:
            return "Neu";
        case USER_ACTIVITY_STATUS.ONLINE:
            return "Kürzlich online";
        case USER_ACTIVITY_STATUS.INSIDER:
            return "Insider";
        case USER_ACTIVITY_STATUS.AMBASSADOR:
            return "Top-Beteiligung";
        default:
            return "";
    }
};
